var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export default gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment PHYSICAL_FORM_FRAGMENT on PhysicalForm {\n    answers\n    kind\n    placeholder\n    required\n    subtitle\n    title\n  }\n"], ["\n  fragment PHYSICAL_FORM_FRAGMENT on PhysicalForm {\n    answers\n    kind\n    placeholder\n    required\n    subtitle\n    title\n  }\n"])));
var templateObject_1;
